import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getMine: {
    method: 'GET',
    url: `${configs.baseUrl}/api/license-requests/me`,
  },
  create: {
    method: 'POST',
    url: `${configs.baseUrl}/api/license-requests`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getMine = async () => {
  const res = await resource.getMine()
  return res.body
}

const create = async (note) => {
  const res = await resource.create({}, note ? { note } : {})
  return res.body.request
}

export default {
  initResource,
  getMine,
  create,
}
